import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: "pusher",
  key: "5553b88b00f6a3f6a023",
  cluster: "ap2",
  forceTLS: true,
});

window.echoDebug = echo; // TEMPORARY - for console testing only

export default echo;